/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { LocalizationActionList, ExcludeSettings, AudienceManagement } from 'components';
import * as S from './CampaignsSettingsPage.styled';
import { useSignal } from '@preact/signals-react';

const campaignSettingsLocalizationPages = [
  {
    name: 'Exclude Settings',
    id: 'ExcludeSettings',
    url_id: '/Discovery/Campaign/Settings/ExcludeSettings',
    disabled: false,
  },
  {
    name: 'Audience Management',
    id: 'AudienceManagement',
    url_id: '/Discovery/Campaign/Settings/AudienceManagement',
    disabled: false,
  },
];

const localRoutersList = [
  {
    id: 'campaign/campaignsSettings/excludeSettings',
    url: 'ExcludeSettings',
    caseSensitive: false,
    element: <ExcludeSettings />,
  },
  {
    id: 'campaign/campaignsSettings/audienceManagement',
    url: 'AudienceManagement',
    caseSensitive: false,
    element: <AudienceManagement />,
  },
];

export const CampaignsSettingsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activePage$ = useSignal('');

  useEffect(() => {
    if (location.pathname.includes('ExcludeSettings')) {
      navigate('ExcludeSettings', { replace: true });
      activePage$.value = 'ExcludeSettings';
      return;
    }
    if (location.pathname.includes('AudienceManagement')) {
      navigate('AudienceManagement', { replace: true });
      activePage$.value = 'AudienceManagement';
      return;
    }
    navigate('ExcludeSettings', { replace: true });
    activePage$.value = 'ExcludeSettings';
  }, []);

  return (
    <S.Container>
      <h1>Campaigns Settings</h1>
      <S.Content>
        <LocalizationActionList
          pages={campaignSettingsLocalizationPages}
          activePage={activePage$}
        />
        <Routes>
          {localRoutersList.map((route) => {
            return (
              <Route
                key={route.id}
                path={route.url}
                element={route.element}
                caseSensitive={route.caseSensitive}
              />
            );
          })}
        </Routes>
      </S.Content>
    </S.Container>
  );
};
